module.exports = __webpack_public_path__ + "resource/img/image003.2445396e.png";